import { MaterialIcon } from "@website/icons/material";
import { Modal } from "@website/ui/modal";
import { deepCompare } from "@website/utils/deep-compare";
import { ReserveGalleryDetail } from "@website/widget/reserve-gallery-detail";
import { useReserveGalleryDetailContainer } from "@website/widget/reserve-gallery/reserve-gallery-detail-container/reserve-gallery-detail-container.hooks";
import { ReserveGalleryDetailContainerPropertiesTypes } from "@website/widget/reserve-gallery/reserve-gallery-detail-container/reserve-gallery-detail-container.types";
import { memo } from "react";

const Component = ({
  title,
  gallery,
  isModalOpen,
  onClose
}: ReserveGalleryDetailContainerPropertiesTypes) => {
  const { containerProps } = useReserveGalleryDetailContainer({
    templateNumber: 4,
    galleryLength: gallery?.length ?? 0
  });

  return (
    <div className={isModalOpen ? "" : "hidden"}>
      <Modal fullScreen onClose={onClose} open={isModalOpen}>
        <div className="border-b-outline-thin flex h-[64px] w-full border-b px-2 md:px-6 xl:px-[calc((100%-1200px)/2)]">
          <div className="flex h-full flex-row items-center justify-start gap-2 lg:max-w-[1200px]">
            <MaterialIcon
              className="text-on-surface-medium-emphasis cursor-pointer text-2xl"
              name="arrow_forward"
              onClick={onClose}
            />
            <span className="text-subtitle-1">
              {title || "گالری تصاویر هتل"}
            </span>
          </div>
        </div>
        <div className="grid h-full grid-cols-2 gap-2 overflow-y-auto p-2 lg:px-[calc((100%-750px)/2)] lg:py-6">
          {containerProps?.map(({ index, rowCount }) => (
            <ReserveGalleryDetail
              gallery={gallery}
              index={index}
              key={`HotelReserveGalleryDetailContainer-${++index}`}
              rowCount={rowCount}
            />
          ))}
        </div>
      </Modal>
    </div>
  );
};
export const ReserveGalleryDetailContainer = memo(Component, deepCompare);
